import {
  minLengthElement,
  requiredElement,
  emailValidElement,
} from "@/services/ValidatorService";
import { i18n } from "@/i18n";
import { reactive } from "vue";

export const userLoginForm = {
  email: {
    value: "",
    props: {
      type: "email",
    },
    rules: [requiredElement, emailValidElement],
  },
  password: {
    value: "",
    props: {
      type: "password",
    },
    rules: [requiredElement, minLengthElement(8)],
  },
};

export const userRegisterForm = {
  email: {
    value: "",
    props: {
      type: "email",
      placeholder: i18n.global.t("login.emailLabel"),
    },
    rules: [requiredElement, emailValidElement],
  },
  password: {
    value: "",
    props: {
      placeholder: i18n.global.t("login.passwordLabel"),
      type: "password",
    },
    rules: [requiredElement, minLengthElement(8)],
  },
  passwordConfirm: {
    value: "",
    props: {
      placeholder: i18n.global.t("login.passwordLabelConfirm"),
      type: "password",
    },
    rules: [requiredElement, minLengthElement(8)],
  },
};

export const loginForm = reactive({
  email: "",
  password: "",
});
export const loginProps = {
  email: {
    type: "email",
    size: "large",
    placeholder: i18n.global.t("login.emailLabel"),
  },
  password: {
    type: "password",
    size: "large",
    autocomplete: "off",
    placeholder: i18n.global.t("login.passwordLabel"),
    "show-password": true,
  },
};
export const loginRules = reactive({
  email: [requiredElement, emailValidElement],
  password: [requiredElement, minLengthElement(8)],
});
